import 'edge/endorsement/app';
import ctrl from './controllers/EndorsementEntryCtrl';
import template from 'text!./views/endorsement-entry.html';

export default angular.module('edge.gateway.endorsement.common.app', ['edge.endorsement.app']).run(['$state', function ($state) {
    ['endorsement', 'endorsementWithPolicy'].forEach(function (stateName) {
        var state = $state.get(stateName);
        state.views[''].template = template;
        state.views[''].controller = ctrl;
    });
}]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/endorsement/common/app.js
// module id = 1771
// module chunks = 0